import { createAction } from "@reduxjs/toolkit";

export const AddFilterKPIMissions = createAction('filterKPIMissions/add');
export const AddPlaqueDateFilterKPIMissions = createAction('filterKPIMissions/addPlaque');
export const AddSelectedMissionsFilterKPIMissions = createAction('filterKPIMissions/addSelectedConsultant');
export const LoadAllFilterKPIMissions = createAction('filterKPIMissions/load');
export const ClearListFilterKPIMissions = createAction('filterKPIMissions/clear');

